import styles from './index.module.scss'
import './node_modules/@fortawesome/fontawesome-free/css/all.min.css'
import { Header } from './components/header/header';
import { Sidebar } from './components/sidebar/sidebar';
import { render } from 'preact';
import { getMenu } from './test/default-menu';

let veyobarVersion = '11.0.0'
let headerRoot
let sidebarRoot


// default side menu to open
if (localStorage.getItem('sideMenuOpen') === null) {
  localStorage.setItem('sideMenuOpen', true)
}

const initializeOpenedMenuItems = () => {
  let openedMenuItems = { items: ["Rescue Dispatch"], subItems: [] };
  let savedOpenedMenuItems = JSON.parse(localStorage.getItem('openedMenuItems'));
  if (!!savedOpenedMenuItems) {
    openedMenuItems = savedOpenedMenuItems;
  }

  localStorage.setItem('openedMenuItems', JSON.stringify(openedMenuItems));
  return openedMenuItems
}

const state = {
  account: null,
  activatedPath: { item: "Rescue Dispatch", subItem: "Trips in OnDemand", finalItem: null },
  appVersions: [{ name: "Veyobar", version: veyobarVersion, environment: "" }],
  area: 'ADMINISTRATOR',
  logoUrl: "",
  logoutCallbackWrapper: null,
  menu: [],
  navigationCallback: null,
  removeMenuItemCallback: null,
  openedMenuItems: initializeOpenedMenuItems(),
  profileMenuOpen: false,
  sideMenuOpen: localStorage.getItem('sideMenuOpen') === 'true',
  versionMenuOpen: false,
  veyobarVersion: veyobarVersion,
}

const initializeAccount = () => {
  let account = null;

  let savedAdminAccount = JSON.parse(localStorage.getItem('veyobarAccount_Administrator'));
  let savedOperatorAccount = JSON.parse(localStorage.getItem('veyobarAccount_Operator'));

  if (!!savedAdminAccount && state.area && state.area.toUpperCase() === 'ADMINISTRATOR') {
    account = savedAdminAccount;
  }

  if (!!savedOperatorAccount && state.area && state.area.toUpperCase() === 'OPERATOR') {
    account = savedOperatorAccount;
  }

  return account
}

const updateArea = (area) => {
  state.area = area.toUpperCase();
  state.account = initializeAccount();
  console.log('update area', state.account, state.account ? state.account.Name : '');
  renderApp()
}

state.account = initializeAccount();


// removes a removable menu item
const removeMenuItem = (item) => {
  let itemName = state.menu[item.quickAccess[0]].Name
  let subItemName = null
  let finalItemName = null

  if (item.quickAccess.length === 1) {
    state.menu.splice(item.quickAccess[0], 1)
  }
  if (item.quickAccess.length === 2) {
    subItemName = state.menu[item.quickAccess[0]].SubItems[item.quickAccess[1]].Name
    state.menu[item.quickAccess[0]].SubItems.splice(item.quickAccess[1], 1)
  }
  if (item.quickAccess.length === 3) {
    subItemName = state.menu[item.quickAccess[0]].SubItems[item.quickAccess[1]].Name
    finalItemName = state.menu[item.quickAccess[0]].SubItems[item.quickAccess[1]].FinalItems[item.quickAccess[2]].Name
    state.menu[item.quickAccess[0]].SubItems[item.quickAccess[1]].FinalItems.splice(item.quickAccess[2], 1)
  }

  // callback to tell app which menu item was removed
  if (!!state.removeMenuItemCallback) {
    state.removeMenuItemCallback(itemName, subItemName, finalItemName)
  }

  setCustomNavigationMenu(state.menu)
}

const setDefaultMenu = (projectKey, environmentKey) => {
  var existingMenu = localStorage.getItem('sideMenu');
  if (!existingMenu) {
    state.menu = getMenu(projectKey, environmentKey)
  } else {
    state.menu = JSON.parse(existingMenu);
  }
  renderApp()
}

const logoutCallbackWrapper = () => {
  localStorage.removeItem('openedMenuItems');
  localStorage.removeItem('sideMenuOpen');
  localStorage.removeItem('sideMenu');
  localStorage.removeItem('veyobarAccount_Administrator');
  localStorage.removeItem('veyobarAccount_Operator');

  state.logoutCallback();
  toggleProfileMenu();
}

// set the navigation menu items from a JSON object in the specified file
const setCustomNavigationMenu = (menu) => {
  state.menu = menu
  localStorage.setItem('sideMenu', JSON.stringify(menu));
  renderApp()
}

// get the navigation menu JSON
const getNavigationMenu = () => {
  return state.menu;
}

// Toggle the sidebar (menu)
const toggleMenu = () => {
  state.sideMenuOpen = !state.sideMenuOpen
  state.versionMenuOpen = false
  localStorage.setItem('sideMenuOpen', state.sideMenuOpen);
  renderApp()
}

// Toggle the version menu
const toggleVersionMenu = () => {
  state.versionMenuOpen = !state.versionMenuOpen
  renderApp()
}

// Toggle the profile menu
const toggleProfileMenu = () => {
  state.profileMenuOpen = !state.profileMenuOpen
  renderApp()
}

// Expand or collapse a sidebar menu item
const toggleMenuItem = (item) => {
  let itemIndex = state.openedMenuItems.items.indexOf(item);
  if (itemIndex < 0) {
    state.openedMenuItems.items.push(item)
  }
  else {
    state.openedMenuItems.items.splice(itemIndex, 1);
  }
  localStorage.setItem('openedMenuItems', JSON.stringify(state.openedMenuItems))
  renderApp()
}

// Expand or collapse a sidebar sub menu item
const toggleMenuSubItem = (item) => {
  let itemIndex = state.openedMenuItems.subItems.indexOf(item);
  if (itemIndex < 0) {
    state.openedMenuItems.subItems.push(item)
  }
  else {
    state.openedMenuItems.subItems.splice(itemIndex, 1);
  }
  localStorage.setItem('openedMenuItems', JSON.stringify(state.openedMenuItems))
  renderApp()
}

// Set a sidebar menu link showing in active status, as if the user is visiting that page
// Every menu item the link is nested under will expand to show this link
const setPathActive = (item, subItem, finalItem) => {
  state.activatedPath = { item, subItem, finalItem };

  // make sure item is open
  if (state.openedMenuItems.items.indexOf(item) < 0) {
    toggleMenuItem(item)
  }

  // make sure sub item is open
  if (state.openedMenuItems.subItems.indexOf(subItem) < 0) {
    toggleMenuSubItem(subItem)
  }

  renderApp()
}

const headerSelector = (state) => {
  return {
    account: state.account,
    toggleMenu,
    toggleProfileMenu,
    sideMenuOpen: state.sideMenuOpen,
    profileMenuOpen: state.profileMenuOpen,
    logoutCallbackWrapper: logoutCallbackWrapper,
  }
}

const setAppVersion = (name, version, environment) => {
  const index = state.appVersions.findIndex(item => item.name === name)
  if (index < 0) {
    state.appVersions.push({ name, version, environment });
  } else {
    state.appVersions[index] = { name, version, environment }
  }
  renderApp()
}

const sidebarSelector = (state) => {
  return {
    account: state.account,
    activatedPath: state.activatedPath,
    appVersions: state.appVersions,
    authToken: state.authToken,
    logoUrl: state.logoUrl,
    menu: state.menu,
    navigationCallback: state.navigationCallback,
    removeMenuItemCallback: state.removeMenuItemCallback,
    openedMenuItems: state.openedMenuItems,
    removeMenuItem: removeMenuItem,
    setPathActive,
    sideMenuOpen: state.sideMenuOpen,
    sideMenuOpen: state.sideMenuOpen,
    toggleMenuItem,
    toggleMenuSubItem,
    toggleVersionMenu,
    versionMenuOpen: state.versionMenuOpen,
    veyobarVersion: veyobarVersion,
  }
}

const hideHeaderAndAdjustRootSize = () => {
  document.getElementById("veyobar-header").className = 'hidden'
  document.getElementById("veyobar-main").className = 'header-hidden'
  document.getElementById("veyo-root").className = 'header-hidden'
}
const hideSidebar = () => {
  document.getElementById("veyobar-sidebar").className = 'hidden'
  document.getElementById("veyo-root").className = 'sidebar-collapsed'
}
const showHeaderAndAdjustRootSize = () => {
  document.getElementById("veyobar-header").className = ''
  document.getElementById("veyobar-main").className = ''
}
const showSidebar = () => {
  document.getElementById("veyobar-sidebar").className = 'showing'
  document.getElementById("veyo-root").className = 'sidebar-open'
}

const renderApp = () => {
  state.sideMenuOpen ? showSidebar() : hideSidebar();
  showHeaderAndAdjustRootSize();
  headerRoot = render(<Header {...headerSelector(state)} />, document.getElementById("veyobar-header"), headerRoot);
  sidebarRoot = render(<Sidebar {...sidebarSelector(state)} />, document.getElementById("veyobar-sidebar"), sidebarRoot);
}

function setAccount(account) {
  state.account = account;
  if (account && account.Role && account.Role.Name && account.Role.Name === 'Administrator') {
    localStorage.setItem('veyobarAccount_Administrator', JSON.stringify(account));
  }

  if (account && account.Role && account.Role.Name && account.Role.Name === 'Operator') {
    localStorage.setItem('veyobarAccount_Operator', JSON.stringify(account));
  }
  renderApp();
}

function update(key, value) {
  state[key] = value;
  renderApp();
}

window.veyobarspace = { renderApp, update, setPathActive, setCustomNavigationMenu, getNavigationMenu, setDefaultMenu, setAppVersion, setAccount, updateArea };



// WEBPACK FOOTER //
// ./index.js